import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import * as Sentry from '@sentry/capacitor';
import * as SentryVue from '@sentry/vue';

import { IonicVue } from '@ionic/vue';
import { vLongPress } from './directives/longPress';
import { applyTextScale } from './utils/textScale';

/**
 * Ionic Dark Mode
 * -----------------------------------------------------
 * For more info, please see:
 * https://ionicframework.com/docs/theming/dark-mode
 */

/* Theme variables */
import './styles/tailwind.css';
import './theme/variables.css';

/* @import '@ionic/vue/css/palettes/dark.always.css'; */
import '@ionic/vue/css/palettes/dark.class.css';
// import '@ionic/vue/css/palettes/dark.system.css';

import 'swiper/css';

import { createPinia } from "pinia";
import { useAppearanceStore } from "@/stores/appearance";

const pinia = createPinia();

const app = createApp(App)
  .use(IonicVue, {
    mode: 'ios',
  })
  .directive('long-press', vLongPress)
  .use(pinia)
  .use(router);

Sentry.init({
    environment: import.meta.env.VITE_BUILD_ENVIRONMENT,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    tracePropagationTargets: ['localhost'],
    // Performance Monitoring
    tracesSampleRate: 0.02, //  Capture 100% of the transactions
    // Since @sentry/capacitor 3 the Vue app is passed through to the sibling SDK
    // instead of at the root. The Session Replay sample rates were dropped from
    // CapacitorOptions; they were inert here anyway without replayIntegration().
    siblingOptions: {
      vueOptions: {
        app,
        attachProps: true,
        attachErrorHandler: true,
      },
    },
  },
// Forward the init method from @sentry/vue
  SentryVue.init
);

// Apply the text scale and colour scheme before mounting so the first paint already has them.
Promise.all([router.isReady(), applyTextScale(), useAppearanceStore(pinia).loadColorScheme()]).then(() => {
  app.mount('#app');
});
